import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import {App} from "./App";
import * as serviceWorker from './serviceWorker';
import { OpenAPI } from "./api";

const server = localStorage.getItem('auto_trading_server') || 'https://stonks.florianhj.fr/api'
const token = localStorage.getItem('auto_trading_token')

OpenAPI.BASE = server;
  
// Set the TOKEN to be retrieved from localStorage
OpenAPI.TOKEN = async () => {
  return token || ''
};

// Optionally set credentials for CORS requests
OpenAPI.WITH_CREDENTIALS = false;

const root = document.getElementById("root");

ReactDOM.createRoot(root!).render(
  <BrowserRouter>
    <Routes>
      <Route path="*" element={<App />} />
    </Routes>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
